"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProductHeading = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const themed_text_1 = require("../themed-text");
exports.StyledProductHeading = (0, styled_components_1.default)(themed_text_1.ThemedHeading) `
  && {
    color: ${(props) => props.theme.palettes.font.productHeader};
  }
`;
